
import React from 'react';
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { MapPin, Phone, ExternalLink, ShoppingBag } from "lucide-react";
import { motion } from "framer-motion";

const LocationCard = ({ location, index }) => {
  return (
    <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: index * 0.1 }}
        className="h-full"
    >
        <Card className="h-full border-none shadow-md hover:shadow-2xl transition-all duration-300 group bg-white overflow-hidden relative">
        <CardContent className="p-8 flex flex-col h-full items-center text-center">
            {/* Optional: Add Store Icon/Image if layout requires it, currently user asked to update "all code" and "place gallery images" but LocationCard design wasn't strictly specified to change layout structure, keeping existing structure but verified logic. The original site had 'LojaX.png' as small images. */}
            {/* If we want to include the image: */}
            <div className="h-12 mb-4">
                 <img src={location.icon} alt={location.name} className="h-full w-auto object-contain" />
            </div>

            <h3 className="text-2xl font-black text-[#E63312] mb-2 group-hover:scale-105 transition-transform duration-300 uppercase leading-tight">{location.name}</h3>
            <p className="text-xs font-bold text-gray-400 mb-6 uppercase tracking-widest border border-gray-200 rounded-full px-3 py-1">
                {location.city}
            </p>
            
            <div className="flex flex-col items-center gap-1 mb-8 flex-grow">
            <div className="flex items-start gap-3 text-gray-700 font-medium justify-center">
                <MapPin className="w-5 h-5 text-[#E63312] mt-1 shrink-0" />
                <span className="text-center leading-tight max-w-[200px]">{location.address}</span>
            </div>
            
            <div className="flex flex-col gap-3 mt-6 w-full">
                {location.phones.map((phone, index) => (
                    <div key={index} className="flex items-center justify-center gap-2 text-gray-600 bg-gray-50 py-2 rounded-lg">
                        <Phone className="w-4 h-4 text-[#E63312]" />
                        <span className="font-semibold">{phone}</span>
                    </div>
                ))}
            </div>
            </div>

            <div className="flex flex-col gap-3 w-full mt-auto">
                <Button 
                    variant="outline" 
                    className="w-full border-2 border-[#E63312] text-[#E63312] font-bold hover:bg-[#E63312] hover:text-white transition-all h-12 uppercase tracking-wide rounded-lg"
                    onClick={() => window.open(location.mapsLink, '_blank')}
                >
                    <ExternalLink className="w-4 h-4 mr-2" />
                    Como Chegar
                </Button>
                <Button 
                    className="w-full bg-[#E63312] hover:bg-black text-white hover:text-[#FFC300] font-bold h-12 uppercase tracking-wide shadow-lg shadow-red-100 rounded-lg transition-all"
                    onClick={() => window.open(location.orderLink, '_blank')}
                >
                    <ShoppingBag className="w-4 h-4 mr-2" />
                    Fazer Pedido
                </Button>
            </div>
        </CardContent>
        </Card>
    </motion.div>
  );
};

export default LocationCard;
